import {
  Component,
  inject,
  OnInit,
  OnDestroy,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AuthService } from '../../services/auth.service';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { EventMessage, EventType } from '@azure/msal-browser';

@Component({
  selector: 'app-splash-screen',
  standalone: true,
  imports: [AngularSvgIconModule, TranslatePipe],
  templateUrl: './splash-screen.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './splash-screen.scss',
})
export class SplashScreenComponent implements OnInit, OnDestroy {
  private msal = inject(MsalService);
  private authService = inject(AuthService);
  private msalBroadcast = inject(MsalBroadcastService);
  private destroy$ = new Subject<void>();

  isLoggingIn = signal(false);

  ngOnInit(): void {
    this.msalBroadcast.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS,
        ),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.isLoggingIn.set(false);
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async login(): Promise<void> {
    if (this.isLoggingIn()) {
      console.warn('Login already in progress');
      return;
    }

    this.isLoggingIn.set(true);
    try {
      await this.authService.loginAsync();
    } catch (error) {
      console.error('Login failed:', error);
      this.isLoggingIn.set(false);
    }
  }

  /**
   * Demo login - Automatski login s demo kredencijalom
   * Bez potrebe za upisivanjem username i password
   */
  async demoLogin(): Promise<void> {
    if (this.isLoggingIn()) {
      console.warn('Demo login already in progress');
      return;
    }

    this.isLoggingIn.set(true);
    try {
      await this.authService.demoLoginAsync();
    } catch (error) {
      console.error('Demo login failed:', error);
      this.isLoggingIn.set(false);
    }
  }
}
